/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Paragraph, Title, useTheme } from "react-native-paper";
import { EBINQUIRY } from "../../../services/services-model.type";
import { spacing } from "@styles/spacing";
import { formatCurrency } from "../../../util/format-currency";
import { Block } from "@block";
import { StackSpacing } from "@components/spacing";
import { Constant } from "app/shared/constant/constant";

interface FEE {
  FEE?: string;
  VAT?: string;
  DISCOUNT?: string;
  TOTAL_FEE_AMOUNT?: string;
  TOTAL_FEE_DEBIT?: string;
  TOTAL_TRANS?: string;
}

interface FeeDetailModalProps {
  data?: EBINQUIRY;
  feeType?: string;
}

export const FeeDetailModalNew = (props: FeeDetailModalProps) => {
  const { data, feeType } = props;
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  const dataNew: FEE = {};
  const [feeData, setData] = React.useState(dataNew);

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: {
          flex: 1,
          height: "100vh",
          maxWidth: 600,
        },
        titleModal: {
          color: colors.accent,
          fontFamily: fonts.medium.fontFamily,
        },
      }),
    [colors.accent, fonts.medium.fontFamily],
  );

  const handlerFee = React.useCallback((): FEE => {
    const obj: FEE = {};
    if (data) {
      console.log("feeType: ", feeType);
      obj.FEE = (
        Number(data?.TOTAL_FEE_AMOUNT || "0") -
        Number(data?.VAT_FEE_AMOUNT || "0") +
        Number(data?.DISCOUNT_AMOUNT || "0")
      ).toString();
      obj.VAT = data.VAT_FEE_AMOUNT;
      obj.TOTAL_FEE_AMOUNT = data?.TOTAL_FEE_AMOUNT || "0";
      obj.DISCOUNT = data.DISCOUNT_AMOUNT;
      obj.TOTAL_FEE_DEBIT =
        feeType === Constant.TRANSFER.TRANSFER_FEE_TYPE.O
          ? (Number(data?.CREDIT_AMOUNT || "0") + Number(data?.TOTAL_FEE_AMOUNT || "0")).toString()
          : data?.CREDIT_AMOUNT;
      obj.TOTAL_TRANS =
        feeType === Constant.TRANSFER.TRANSFER_FEE_TYPE.O
          ? data?.CREDIT_AMOUNT
          : (Number(data?.CREDIT_AMOUNT || "0") - Number(data?.TOTAL_FEE_AMOUNT || "0")).toString();
    }
    return obj;
  }, [data, feeType]);

  React.useEffect(() => {
    console.log("handlerFee");
    setData(handlerFee);
  }, [handlerFee]);

  const rowItemFee = (title: string = "", value: string = "") => {
    return (
      <>
        <StackSpacing size="medium" />
        <Block row>
          <Block flex={0.5}>
            <Paragraph style={[fonts.regular, { color: colors.placeholder, fontWeight: "700" }]}>{title}</Paragraph>
          </Block>
          <Block right flex={0.5}>
            <Paragraph style={[fonts.regular, { color: colors.accent, fontWeight: "700" }]}>{value}</Paragraph>
          </Block>
        </Block>
        <StackSpacing size="medium" />
      </>
    );
  };

  const TitleModal = (
    <React.Fragment>
      <Block ph={spacing.huge} pv={spacing.medium}>
        <Title style={styles.titleModal}>{t("FEE_CHI_TIET_PHI")}</Title>
      </Block>
    </React.Fragment>
  );

  const FormContent = (
    <React.Fragment>
      <Block flex={1} ph={spacing.macro} pv={spacing.medium}>
        {rowItemFee(t("FEE_PHI") + ":", formatCurrency(feeData.FEE))}
        {rowItemFee(t("FEE_VAT") + ":", formatCurrency(feeData.VAT))}
        {rowItemFee(t("FEE_GIAM_PHI") + ":", formatCurrency(feeData.DISCOUNT))}
        {rowItemFee(t("FEE_TONG_PHI") + ":", formatCurrency(feeData.TOTAL_FEE_AMOUNT))}
        {rowItemFee(t("FEE_TONG_GHI_NO") + ":", formatCurrency(feeData.TOTAL_FEE_DEBIT))}
        {rowItemFee(t("FEE_TONG_THUC_CHUYEN") + ":", formatCurrency(feeData.TOTAL_TRANS))}
      </Block>
    </React.Fragment>
  );

  return (
    <>
      {TitleModal}
      {FormContent}
    </>
  );
};
